export default {
    container: 'search__autosuggest position-relative',
    suggestionsContainer: 'search__dropdown position-absolute bg-white border-left border-right border-bottom rounded-bottom',
    suggestionsList: 'search__dropdown-menu m-0 p-0 bg-white h-100',
    suggestion: 'search__dropdown-item suggestion__text px-3 py-3',
    input: 'search__input form-control cc-form-control',
    suggestionHighlighted: 'active bg-at-ocean-tint-10',
    sectionContainer: 'search__section-container',
    sectionTitle: 'search__section-title border-top px-3 text-right text-uppercase',
};
